import { Grid, IconButton, Slider } from '@mui/material'
import { VolumeUp, VolumeOff} from '@mui/icons-material/'

import { Icons } from '../Icons'
import iconPlay from '../../assets/icons/playerPlay.svg'
import iconPause from '../../assets/icons/playerPause.svg'
import SliderWithPreview from './SliderWithPreview'

export default function PlayerVerticalControls(props) {
  const {
    controlsVisibility,
    muted,
    onMute,
    onPlayPause,
    onSeek,
    onSeekMouseDown,
    onSeekMouseUp,
    onVolumeChange,
    onVolumeSeekUp,
    played,
    playing,
    media: {
      order,
      season,
      serie,
      title,
    },
    type,
    volume,
    vttContent,
    baseUrlImage,
    duration,
    setIsSeeking
  } = props

  let episode = ' ';
  
  if (type !== 'live') {
    if (serie) {
      const seasonText = serie.seasons.length > 1 ? `T${season.order}:` : '';
      const hasVods = (serie.seasons[0]?.vods?.length ?? 0) > 0;
      const episodeText = hasVods ? `${Number(order) + 1}` : '';
      episode = `${seasonText}${episodeText}`;
    }
  }

  return (
    <>
      <div className={controlsVisibility ? 'controlsWrapper verticalControlsWrapper' : 'controlsWrapper verticalControlsWrapper hide'}>
        {/* Top controls */}
        <Grid container direction='row' justifyContent='space-between' alignItems='center' className='topControls'>
          <Grid item>
            <div className='audioWrapper'>
              {/* mute */}
              <IconButton onClick={onMute} className=''>
                {muted ? <VolumeOff /> : <VolumeUp />}
              </IconButton>
              <Slider
                className='volumeSlider'
                min={0}
                max={100}
                value={muted ? 0 : volume}
                defaultValue={50}
                onChange={onVolumeChange}
                onChangeCommitted={onVolumeSeekUp}
              />
            </div>
          </Grid>
        </Grid>
        {/* Middle controls */}
        <Grid container direction='row' alignItems='center' justifyContent='center'>
          <Grid item>
            <IconButton onClick={onPlayPause} className='controlIcons bigPlay'>
              {playing ? <Icons path={iconPause} /> : <Icons path={iconPlay} />}
            </IconButton>
          </Grid>
        </Grid>
        {/* Bottom controls */}
        <Grid container direction='row' alignItems='center' justifyContent='space-between' className='bottomControls'>
          <h3 className='title'>
            <span>{episode}</span>
            {title}
          </h3>
          {type !== 'live' &&
            <Grid item xs={12} className='sliderLayout'>
              <SliderWithPreview
                vttContent={vttContent}
                played={played}
                onSeek={onSeek}
                onSeekMouseDown={onSeekMouseDown}
                onSeekMouseUp={onSeekMouseUp}
                baseUrlImage={baseUrlImage}
                duration={duration}
                setIsSeeking={setIsSeeking}
              />
            </Grid>
          }
        </Grid>
      </div>
    </>
  )
}
